module.exports = __webpack_public_path__ + "img/BEBADO_V2.9f2fcf35.jpg";